/**
 * Join class names, dropping anything absent.
 *
 * `noUncheckedIndexedAccess` makes a CSS-module lookup `string | undefined`, which is correct —
 * a typo in a class name should not silently render unstyled. This is the one place that is
 * resolved, rather than at every call site.
 */
export function cx(...names: Array<string | false | null | undefined>): string {
  return names.filter(Boolean).join(' ');
}
